import { getLocalStorageAccessToken } from '../helpers/auth';
import { NG_IMPERSONATE_FEATURE_KEY } from '../store/impersonate.slice';
import { captureError, pmSessionIdSelectors } from '@clatter/platform';

export const prepareHeaders = (headers: any, api: any) => {
  const { endpoint, getState } = api || {};

  if (endpoint === 'uploadFile') {
    // Do not set the Authorization header for the uploadFile endpoint
    return headers;
  }

  const authToken = getLocalStorageAccessToken();

  if (authToken) {
    headers.set('Authorization', `Bearer ${authToken}`);
  }

  const impersonated = getState()?.[NG_IMPERSONATE_FEATURE_KEY]?.impersonated;

  if (impersonated) {
    const impersonatedToken = impersonated?.accessToken;

    if (!impersonatedToken) {
      captureError(new Error('Could not set impersonated header: no impersonated token'), { component: 'services/helpers', skipConsole: true });
      return headers;
    }

    headers.set('X-Clatter-Impersonate', `Bearer ${impersonatedToken}`);
  }

  const pmSessionId = pmSessionIdSelectors.getPmSessionId(getState());

  if (pmSessionId) {
    headers.set('X-Clatter-Presentation-Session-Id', pmSessionId);
  }

  return headers;
};
